import { Button } from "@shared/components/button";
import { PoMLogo } from "@shared/components/pom-logo";
import { AuthorLogo } from "@shared/components/author-logo";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@shared/components/tooltip";
import {
  SignedIn,
  SignedOut,
  SignInButton,
  UserButton,
} from "@clerk/clerk-react";
import { Link, useLocation } from "react-router-dom";
import { dark } from "@clerk/themes";

export function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <main className="app-container">{children}</main>
      <Header />
    </>
  );
}

function Header() {
  const location = useLocation();
  const isMapsPage = location.pathname === "/maps";
  const isEditorPage =
    location.pathname === "/" || location.pathname.startsWith("/map/");
  const isAboutPage = location.pathname === "/about";

  return (
    <header className="p-4 fixed top-0 left-0 right-0 z-50 flex justify-between items-start pointer-events-none">
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href="https://m0rtyn.cc"
            target="_blank"
            rel="noopener noreferrer"
            className="pointer-events-auto hover:opacity-80 transition-opacity text-foreground/70 hover:text-foreground p-1.5 border-2 border-foreground/30 rounded-md"
            aria-label="Visit author's website"
          >
            <AuthorLogo className="size-5" />
          </a>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>Author&apos;s website</p>
        </TooltipContent>
      </Tooltip>

      {/* <Link to="/" className="pointer-events-auto hover:opacity-90 transition-opacity">
        <PoMLogo className="h-20 w-48 -mt-2 -ml-2" />
      </Link> */}

      <div className="flex gap-4 items-center pointer-events-auto">
        <div className="flex gap-2 items-center pointer-events-auto">
          <Link to="/">
            <Button
              variant="link"
              size="sm"
              disabled={isEditorPage}
            >
              Editor
            </Button>
          </Link>
          <Link to="/maps">
            <Button
              variant="link"
              size="sm"
              disabled={isMapsPage}
            >
              Maps
            </Button>
          </Link>
          <Link to="/about">
            <Button
              variant="link"
              size="sm"
              disabled={isAboutPage}
            >
              About
            </Button>
          </Link>
        </div>

        <SignedOut>
          <SignInButton>
            <Button>Sign In</Button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <UserButton
            appearance={{
              theme: dark,
            }}
          />
        </SignedIn>
      </div>
    </header>
  );
}
